import React from "react";
import { WhatsAppIcon } from "./icons/WhatsAppIcon";

const WHATSAPP_NUMBER = "393494062553"; // +39 349 406 2553

export default function WhatsAppButton() {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    "Ciao NSA Motors, vorrei una informazione."
  )}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contattaci su WhatsApp"
      title="Contattaci su WhatsApp"
      data-testid="whatsapp-float"
      // Bottom-right, raised above the "Made with Emergent" badge (~52px)
      style={{ bottom: "5.5rem" }}
      className="fixed z-[60] right-4 md:right-6 h-14 w-14 flex items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl hover:shadow-2xl hover:scale-110 active:scale-95 transition-all"
    >
      <WhatsAppIcon size={28} />
    </a>
  );
}
